<app-page-header></app-page-header>

<app-unauthenticated-menu></app-unauthenticated-menu>

<section class="vh-90" style="background-color: #b0cafa;">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div class="card shadow-2-strong" style="border-radius: 1rem;">
          <div class="card-body p-5 text-center">

            <h3 class="mb-5">
              {{ 'Main.UserAccess' | translate }}
            </h3>

            <div class="form-outline mb-4">
              <input type="email" id="typeEmailX-2" class="form-control form-control-lg" [(ngModel)]="userName"/>
              <label class="form-label" for="typeEmailX-2">
                {{ 'Main.User' | translate }}
              </label>
            </div>

            <div class="form-outline mb-4">
              <input type="password" id="typePasswordX-2" class="form-control form-control-lg" [(ngModel)]="password"/>
              <label class="form-label" for="typePasswordX-2">
                {{ 'Main.Password' | translate }}
              </label>
              <div class="form-outline mb-4" *ngIf="loginAttempted === true && validPassword === false">
                <label class="form-label" style="color: rgb(236, 77, 77);">
                  {{ 'Main.WrongLogin' | translate }}
                </label>
              </div>
            </div>

            <div class="form-outline mb-4">
              <button class="btn btn-primary btn-lg btn-block" (click)="UserLogin()" [disabled]="userName ==='' || password==='' || loading">Login</button>
              <button *ngIf="loading" class="btn ms-3" disabled>
                <span class="spinner-border spinner-grow-sm"></span>
                {{ 'Main.Loading' | translate }}
              </button>
            </div>

            <div class="form-outline mb-4">
              <a [routerLink]="['/forgot-password']">
                {{ 'Main.ForgotPassword.ForgottenPassword' | translate }}
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
